module.exports = __webpack_public_path__ + "static/media/400063_02.b9a49b7c.png";